export const formatDateLongMonthYearNumber = (dateString: string) =>
  new Date(dateString).toLocaleDateString('nl-BE', {
    month: 'long',
    year: 'numeric',
  });

export const getCurrentYear = () => new Date().getFullYear();

const MONTHS: Record<string, string[]> = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  nl: [
    'Januari',
    'Februari',
    'Maart',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Augustus',
    'September',
    'Oktober',
    'November',
    'December',
  ],
  fr: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Aout',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
};

export const formatMonthTitle = (d: Date, locale: string) => {
  return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
};
